import * as Enumerable from 'linq';
import { Payment } from './payment';
import { PaymentSummary } from './payment.view';
import { Entity } from '../entity';



export class PaymentUtility {

    public static getReconcileDataTree(payments: Payment[]): PaymentSummary[] {

        const receiverGroup = Enumerable
            .from(payments)
            .where(e => !!e.receiver?._id)
            .select(e => e.receiver)
            .distinct(e => e._id)
            .select(x => {

                const amount = Enumerable.from(payments)
                    .where(p => p.receiver?._id === x?._id)
                    .sum(p => p?.amount);

                return {
                    _id: x._id,
                    path: [x.name],
                    amount: amount ?? 0,
                    receiver: x,
                    status: null
                } as any;
            })
            .toArray();

        const methodGroup = Enumerable
            .from(payments)
            .where(e => !!e.receiver?._id && !!e.method?._id)
            .select(e => {

                const amount = Enumerable.from(payments)
                    .where(p => p.receiver?._id === e.receiver?._id && p.method?._id === e.method?._id)
                    .sum(p => p?.amount);


                return {
                    _id: `${e?.receiver?._id}::${e.method?._id}`,
                    receiver: e.receiver,
                    method: e.method,
                    amount: amount
                } as any
            })
            .distinct(e => e._id)
            .select(x => {

                return {
                    _id: x._id,
                    path: [x.receiver?.name, x.method?.name],
                    amount: x.amount ?? 0,
                    receiver: x.receiver,
                    method: x.method,
                    status: null
                };
            })
            .toArray();

        const paymentGroup = Enumerable
            .from(payments)
            .where(e => !!e.receiver?._id && !!e.receiver?._id)
            .groupBy(e => `${e.receiver?._id}-${e.method?._id}`)
            .selectMany(e => {

                const items = Enumerable.from(e.getSource())
                    .select(i => {

                        return {
                            ...i,
                            path: [i.receiver?.name, i.method?.name, i._id]
                        }
                    });

                return items;
            })
            .toArray();

        return [...receiverGroup, ...methodGroup, ...paymentGroup];
    }

    public static getValidPayment(payment: Payment, currentUser: Entity): Payment {

        return {
            ...payment,
            createdBy: {
                _id: currentUser?._id,
                name: currentUser?.name
            }
        }
    }

}